<template>
  <div>
    <div class="foot">
      <!-- <pp v-if="chatServicePic && !routePath" :chatServicePic="chatServicePic" :haveBottomBtn="permissions && permissions.includes('cs_working') && type=='home'"></pp> -->
      <!-- <div v-if="permissions && permissions.includes('cs_working') && type=='home'" class="hh">
        <div class="floatingView pointer" ref="showDoc" @click.stop="floatingTap"></div>
      </div> -->
      <div class="box XYcenter flexDirection">
        <div class="XYcenter widthPercent100 size12 borderBox XsbYcenter" v-show="type=='home'" style="padding:0 20%">
          <div class="XYcenter flexDirection pointer" :class="{'color40':status==2}" @click="tabClick('home','2')">
            <i class="iconfont size22" :class="status==2 ? 'iconshouye':'iconshouye1'"></i>首页
          </div>
          <div class="XYcenter flexDirection pointer" :class="{'color40':status==3}" @click="tabClick('home','3')">
            <i class="iconfont size22" :class="status==3 ? 'icondingdan':'icondingdan1'"></i>订单
          </div>
        </div>
        <van-row type="flex" align="center" justify="center" class="widthPercent100" v-show="type=='next'">
          <van-row class="positionButt120" v-if="buttMoreBoxBool">
            <van-row class="buttMoreBox backF1 textCenter borderBottF2 themeColor"
                    @click="tabClick('next',tt.key)" v-for="tt in buttClickArr" :key="tt.key">{{ tt.name }}
            </van-row>
          </van-row>
          <van-col span="5" class="height50 XYcenter backF flexDirection pointer" @click="tabClick('next','1')">
            <i class="iconfont size22 " :class="{'iconshouye1 ':isHome,'iconfanhui':!isHome,}"></i>
            <span class="size12 color66">{{isHome ? '首页':'返回'}}</span>
          </van-col>
          <van-col v-if="isCancelQuote" span="5" class="height50 borderLeftF XYcenter textCenter size14 color66 pointer" @click="tabClick('next','11')">撤单</van-col>
          <van-col :disabled="isDisabled" :span="isCancelQuote?10:14" class="height50 zIndex13 flex1" @click="tabClick('next','3')">
            <button :disabled="isDisabled" :class="{'disabledButt':isDisabled}"
                    class="height50 bgColor nextBtn pointer XYcenter"><i class="iconfont size22 iconfanhui marRight6" v-show="buttText == '返回'"></i>{{ buttText }}
            </button>
          </van-col>
        </van-row>

        <van-row type="flex" align="center" justify="center" class="height50" v-show="type=='price'">
          <van-row class="positionButt2 backF" v-if="buttMoreBoxBool">
            <van-row class="buttMoreBox backF1 textCenter borderBottF2 themeColor"
                    @click="tabClick('next',tt.key)" v-for="tt in buttClickArr" :key="tt.key">{{ tt.name }}
            </van-row>
          </van-row>
          <van-col span="5" class="height50 XYcenter backF borderRightDD" @click="tabClick('home','2')">
            <i class="iconfont size22 themeColor iconshouye1"></i>
          </van-col>
          <van-col span="5" class="height50 XYcenter backF borderRightDD" @click="tabClick('next','2')">
            <i class="iconfont iconkefu size22 themeColor"></i>
          </van-col>
          <van-col span="5" class="height50 XYcenter backF" @click="tabClick('next','1')">
            <i class="iconfont iconfenxiang size22 themeColor"></i>
          </van-col>
          <van-col :disabled="isDisabled" span="9" class="height50 zIndex13" @click="tabClick('next','3')">
            <button :disabled="isDisabled" :class="{'disabledButt':isDisabled}"
                    class="height50 XYcenter bgColor colorF app">{{ buttText }}
            </button>
            <!--{{buttText}}-->
          </van-col>
        </van-row>

        <van-popup v-model="customerServiceBool" position="bottom" overlay-class="bottom60" closeable :lock-scroll="false">
          <customer-service :isFootTab="true"></customer-service>
        </van-popup>
      </div>
    </div>
  </div>
</template>

<script type="es6">
import Floating from '../floating/Floating';
import customerService from '../customerService/customerService'
import pp from './pp.vue'

export default {
  components: {
    customerService,
    Floating,
    pp
  },
  props: {
    type: {
      type: String,
      default: 'next'
    },
    status: {
      type: String,
      default: '2'
    },
    buttText: {
      type: String,
      default: '下一步'
    },
    buttClickArr: {
      type: Array,
      default: () => {
        return []
      }
    },
    isHome: {
      type: Boolean,
      default: false
    },
    isCancelQuote: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      maskHomeBool: false,
      customerServiceBool: false,
      buttMoreBoxBool: false,
      permissions: sessionStorage['permissions'] ? JSON.parse(sessionStorage['permissions']) : '',
      isMobile:false,
      coordinate: {
        client: {},
        elePosition: {}
      },
      show: false,
    }
  },
  created() {
    let mobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
    this.isMobile = mobile ? true : false
  },
  computed: {
    chatServicePic() {
      return this.$store.state.chatServicePic
    },
    routePath() {
      return this.$route.path === '/myOrder'
    },
  },

  mounted() {
  },
  methods: {
    tabClick(type, status) {
      if (type == 'next') { //有下一步的时候
        if (status == 2) {//客服
          this.customerServiceBool = !this.customerServiceBool
        } else if (status == 1) {
          if (this.buttClickArr.length) {
            this.buttMoreBoxBool = !this.buttMoreBoxBool
          } else {
            this.$emit('tabClick', type, status)
          }
        } else {
          this.$emit('tabClick', type, status)
        }
      } else {
        this.$emit('tabClick', type, status)
      }
    },
    floatingTap(el) {
      let isClick = el.target.parentNode.getAttribute('flag')
      if(isClick ==='false') return false
      let drag = el.target.parentNode.getAttribute('drag')
      if (drag === 'no') {
        el.target.parentNode.setAttribute('drag', null)
        el.target.parentNode.classList.add('acc')
        return false
      }
      let token = this.commonJs.getQueryString('token') || localStorage['token']
      let h5Href = ''
      let branchId = localStorage['branchId'] ? localStorage['branchId'] : ''
      let locationHost = window.location.host
      if (locationHost.includes('localhost') || locationHost.includes('80')) {
        h5Href = `http://localhost:8081/${this.isMobile ? 'h5/dff/home':'pc/dff/workbench'}?token=${token}&branchId=${branchId}`;
      } else {
        if (window.location.href.includes('https')) {
          h5Href = `https://${locationHost}/${this.isMobile ? 'h5/dff/home':'pc/dff/workbench'}?token=${token}&branchId=${branchId}`;
        } else {
          h5Href = `http://${locationHost}/${this.isMobile ? 'h5/dff/home':'pc/dff/workbench'}?token=${token}&branchId=${branchId}`;
        }
      }
      window.location.href = h5Href
    },
  },
}
</script>

<style lang='scss' scoped>
@import "../../scss/_handle.scss";
.box{
  box-shadow: 0px -1px 8px 0px rgba(0,0,0,0.3);
  height:50px;
}
.floatingView {
  background: url('../../../static/images/h5HomeIcon.png') #fff;
  background-size: cover;
  width: 68px;
  height: 68px;
  border-radius: 50%;
}

.positionButt120 {
  position: absolute;
  left: 0;
  bottom: 12rem;
}

.positionButt2 {
  position: absolute;
  left: 35%;
  bottom: 12rem;
}

.footBoxLeft {
  background: url('../../assets/menu_left.png') no-repeat;
  background-size: 100% 100%;
  padding-top: 3px;
}

.bgColor {
  background: linear-gradient(to bottom, $mainColor 0%, $mainColor 100%);
}

.footBoxRight {
  background: url('../../assets/menu_right.png') no-repeat;
  background-size: 100% 100%;
  padding-top: 3px;
}

.menu_left_on {
  @include backgroundImage("menu_left_on.png");
  background-size: 100% 100%;
  padding-top: 3px;
}

.menu_right_on {
  @include backgroundImage("menu_right_on.png");
  background-size: 100% 100%;
  padding-top: 3px;
}

/*.footBoxRightBlueClick{*/
/*background: url('../../assets/menu_right_on.png') no-repeat;*/
/*background-size: 100% 100%;*/
/*padding-top: 3px;*/
/*color: #fff !important;*/
/*}*/

.homeBtn {
  position: absolute;
  width: 15rem;
  height: 15rem;
  bottom: 3rem;
  left: 50%;
  transform: translate(-50%, 0px);
  z-index: 10;
  border-radius: 50%;
  box-shadow: 0px 2px 11px 2px rgba(157, 157, 157, 0.42);
}

.clickStyle {
  color: #FFFFFF !important;
  background-color: $mainColor !important;
}

.buttMoreBox {
  width: 22rem;
  padding: 3rem 0;
}

/deep/ .bottom60 {
  height: calc(100% - 12rem) !important;
}

.bottom60 + .van-popup {
  bottom: 12rem !important;
}

.disabledButt {
  cursor: not-allowed;
  background:#999!important;
  color:#333!important;
}

.maskHome {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.9);
  width: 100vh;
  height: 100vh;
}

.hh {
  width: 68px;
  height: 68px;
  border-radius: 50%;
  position: fixed;
  bottom: 80px;
  right: -32px;
  z-index: 99;
  animation: all 5s;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.h_list {
  position: absolute;
  box-sizing: border-box;
  right: 0;
  overflow: hidden;
  transition: 0.5s all;
}
.h_list a {
  display: block;
  text-align: center;
  /* margin-top: 12px; */
  // transition: 0.8s all;
}
.titBox {
  width: 20rem;
  height: 12rem;
  position: absolute;
  top: 0;
  right: 0;
  line-height: 12rem;
  transition: 0.5s all;
  z-index: 1;
  background: #ffffff;
  color: #406cff;
  font-size: 13px;
}

.bgColorW{
 color: $mainColor !important;
  background-color: white;
}
.nextBtn{
  border:none;
  width:100%;
  text-align:center;
  line-height:50px;
  color:#fff;
  font-size:16px;
}
</style>



// WEBPACK FOOTER //
// src/components/base/footTab.vue